import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddEditSurchargeForm = (strings: any, width = 4): FormModel[] => {
  const isFilter = width === 12;
  return [
    {
      label: strings.taxCode_text_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators:
        width === 12
          ? []
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: width },
      required: width === 4,
    },
    {
      label: strings.taxCode_text_percentage,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'percentage',
      inputProps: { min: 0, max: 100 },
      validators:
        width === 12
          ? []
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat, max: 100 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: width },
      required: width === 4,
    },
  ];
};
